import { render, staticRenderFns } from "./Mappa.vue?vue&type=template&id=32c28732&scoped=true&lang=pug&"
import script from "./Mappa.vue?vue&type=script&lang=ts&"
export * from "./Mappa.vue?vue&type=script&lang=ts&"
import style0 from "./Mappa.vue?vue&type=style&index=0&id=32c28732&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c28732",
  null
  
)

export default component.exports